import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import Portal from '../../../../components/Portal';
import Icon from '../../../../components/Icon';
import styles from './MilestoneCompletionModal.m.sass';
import MilestoneProgress from '../MilestoneProgress';
import ConfettiCannon from '../ConfettiCannon';
import { BodyClass, HtmlClass } from '../../../../components/ClassName';
var MilestoneCompletionModal = function MilestoneCompletionModal(_ref) {
  var state = _ref.state;
  var modal = state.completionModal;
  if (!modal.showing) {
    return null;
  }
  var isLast = modal.allMilestonesCompleted;
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(BodyClass, {
    className: styles.body
  }), /*#__PURE__*/React.createElement(HtmlClass, {
    className: styles.body
  }), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.overlay
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.top
  }, /*#__PURE__*/React.createElement("a", {
    onClick: modal.hide,
    className: styles.closeBtn
  }, /*#__PURE__*/React.createElement(Icon, {
    material: true,
    name: "close"
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.cannon
  }, /*#__PURE__*/React.createElement(ConfettiCannon, {
    delay: 800
    // Where to spawn the confetti.
    // This should be at the trophy opening.
    ,
    confettiSource: {
      width: 5,
      x: 195,
      y: 85
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.progress
  }, /*#__PURE__*/React.createElement(MilestoneProgress, {
    size: "big",
    totalCount: 1,
    completedCount: 1,
    spin: true
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.title
  }, "Congrats! ", /*#__PURE__*/React.createElement("br", null), isLast ? 'That was the last Milestone!' : "You've completed a Milestone!"), /*#__PURE__*/React.createElement("p", {
    className: styles.description
  }, isLast ? "This is the moment we've all been waiting for!" : "You're another step closer to finishing this job!")), /*#__PURE__*/React.createElement("div", {
    className: styles.actions
  }, /*#__PURE__*/React.createElement(Action, {
    primary: true,
    onClick: modal.proceed
  }, isLast ? "Awesome!" : "Proceed to Next Milestone"), !isLast && /*#__PURE__*/React.createElement(Action, {
    onClick: modal.hide
  }, "I'm not ready yet")))));
};
export default observer(MilestoneCompletionModal);
var Action = function Action(_ref2) {
  var children = _ref2.children,
    primary = _ref2.primary,
    onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement("a", {
    onClick: onClick,
    className: cx(styles.action, primary ? styles.primary : styles.secondary)
  }, children);
};
//# sourceMappingURL=index.js.map
